import "./banner.css";
import { useState, useEffect } from "react";
import api from "../../constants/api.js";
import Modal from "../../components/modal/modal.jsx";
import BtnVoltar from "../../components/btn-voltar/btn-voltar.jsx";
import { useNavigate } from "react-router-dom";

function Banner() {
  const [banners, setBanners] = useState([]);
  const [img, setImg] = useState(null);
  const [open, setOpen] = useState(false);
  const [editandoId, setEditandoId] = useState(null);
  const [campoImagem, setCampoImagem] = useState("banner");

  const navigate = useNavigate();

  useEffect(() => {
    async function fetchBanners() {
      const response = await api.get("/banners");
      setBanners(response.data || []);
    }
    fetchBanners();
  }, []);

  function editarBanner(banner, campo) {
    setImg(campo === "banner_mobile" ? banner.banner_mobile : banner.banner);
    setCampoImagem(campo);
    setEditandoId(banner.id_banner);
    setOpen(true);
  }

  async function enviarEdit() {
    const formData = new FormData();

    if (img instanceof File) {
      formData.append(campoImagem, img);
    }

    const response = await api.put(`/banners/${editandoId}`, formData);

    setBanners(prev =>
      prev.map(b => (b.id_banner === editandoId ? response.data : b))
    );

    setOpen(false);
    setImg(null);
    setEditandoId(null);
  }

  const bannerQuadrado = banners.find(b => b.tipo === "quadrado");
  const bannerRetangulo = banners.find(b => b.tipo === "retangulo");

  return (
    <div className="container-banners">
      <div className="header-banners">
        <h1>Editar Banners</h1>
        <BtnVoltar voltar={() => navigate("/home")} />
      </div>

      <div className="banners">
        <div className="banner">
          <h3>Banner Retângulo (Desktop)</h3>
          {bannerRetangulo?.banner && <img src={bannerRetangulo.banner} />}
          <button onClick={() => editarBanner(bannerRetangulo, "banner")}>
            Editar
          </button>
        </div>

        <div className="banner">
          <h3>Banner Quadrado</h3>
          {bannerQuadrado?.banner && <img src={bannerQuadrado.banner} />}
          <button onClick={() => editarBanner(bannerQuadrado, "banner")}>
            Editar
          </button>
        </div>

        <div className="banner">
          <h3>Banner Retângulo (Mobile)</h3>
          {bannerRetangulo?.banner_mobile && (
            <img src={bannerRetangulo.banner_mobile} />
          )}
          <button
            onClick={() =>
              editarBanner(bannerRetangulo, "banner_mobile")
            }
          >
            Editar
          </button>
        </div>
      </div>

      <Modal
        isOpen={open}
        setOpen={setOpen}
        enviar={enviarEdit}
        tipo="banner"
        img={img}
        setImg={setImg}
      />
    </div>
  );
}

export default Banner;
